import React from 'react'

const SvgDoc1 = props => (
  <svg fill='none' width={40.303} height={40.303} viewBox='0 0 40.303 40.303' {...props}>
    <defs>
      <linearGradient x1={0.5} y1={0} x2={0.5} y2={1} id='doc1_svg__b'>
        <stop offset='0%' stopColor='#FFF' />
        <stop offset='97.143%' stopColor='#FFF' stopOpacity={0} />
      </linearGradient>
      <filter
        id='doc1_svg__a'
        filterUnits='objectBoundingBox'
        colorInterpolationFilters='sRGB'
        x={0}
        y={0}
        width={33}
        height={37}
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur in='BackgroundImage' stdDeviation={5.05} />
        <feComposite in2='SourceAlpha' operator='in' result='effect1_foregroundBlur' />
        <feBlend in='SourceGraphic' in2='effect1_foregroundBlur' result='shape' />
      </filter>
    </defs>
    <path
      d='M28.095 7.097L16.853.503A3.634 3.634 0 0015 0c-.637 0-1.275.17-1.852.503L1.898 7.097C.728 7.785 0 9.068 0 10.46v13.08c0 1.392.728 2.675 1.897 3.363l11.25 6.595c.578.34 1.216.502 1.853.502s1.275-.17 1.852-.502l11.25-6.595C29.273 26.215 30 24.932 30 23.54V10.46c0-1.392-.727-2.675-1.898-3.363h-.007z'
      fill='#FF5F23'
    />
    <g filter='url(#doc1_svg__a)'>
      <path
        d='M37.904 10.723L25.538 3.547A4.03 4.03 0 0023.5 3c-.701 0-1.402.185-2.038.547L9.087 10.723A4.232 4.232 0 007 14.383v14.234c0 1.515.8 2.911 2.087 3.66l12.375 7.176c.636.37 1.337.547 2.038.547.701 0 1.402-.185 2.038-.547l12.375-7.176A4.232 4.232 0 0040 28.617V14.383c0-1.515-.8-2.911-2.087-3.66h-.008z'
        fill='#F4C4B2'
        fillOpacity={0.5}
      />
      <path
        d='M21.31 39.715q1.01.588 2.19.588 1.158 0 2.188-.586l12.377-7.178q1.037-.603 1.637-1.655.601-1.052.601-2.267V14.383q0-1.215-.6-2.267-.601-1.052-1.638-1.655l-.07-.04h-.009L25.69 3.284q-1.009-.588-2.19-.588-1.158 0-2.188.587L8.935 10.46q-1.037.603-1.637 1.655-.601 1.052-.601 2.267v14.234q0 1.215.6 2.267.601 1.052 1.638 1.655l12.375 7.176zm2.19-.018q-1.017 0-1.885-.506L9.24 32.015q-.896-.521-1.416-1.431-.521-.912-.521-1.967V14.383q0-1.054.521-1.967.52-.91 1.415-1.43L21.612 3.81q.89-.507 1.888-.507 1.017 0 1.886.506l12.437 7.217h.006q.848.516 1.347 1.39.521.912.521 1.967v14.234q0 1.054-.521 1.967-.52.91-1.415 1.43L25.388 39.19q-.89.507-1.888.507z'
        fillRule='evenodd'
        fill='url(#doc1_svg__b)'
      />
    </g>
    <path
      d='M30.9 16.13H19.003v2.086h12.545l-2.1 2.274L30.871 22l2.753-2.98 1.377-1.49-.987-1.047v-.353h-.333l-.103-.11L30.73 13l-1.376 1.49 1.545 1.64zm-12.898 0H15v2.086h3.002V16.13zM30.014 24.484L31 25.53 26.87 30l-1.423-1.51 2.1-2.274H15.004V24.13H26.9l-1.546-1.64L26.731 21l2.95 3.13h.333v.354zm-16.012-.354H11v2.086h3.002V24.13z'
      fillRule='evenodd'
      fill='#FFF'
    />
  </svg>
)

export default SvgDoc1
